import React from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthPage from "./pages/AuthPage";
import Inventory from "./pages/Inventory";
import Profile from "./pages/Profile";
import PublicProfileFeed from "./pages/PublicProfileFeed";
import PublicProfile from "./pages/PublicProfile";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";

const AppContent: React.FC = () => {
  const { user, loading } = useAuth();

  // Block rendering until Firebase finishes checking auth state
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-100 to-indigo-200">
        <div className="text-lg text-gray-600">Loading...</div>
      </div>
    );
  }

  return (
    <>
      {user && <Navbar />}
      <Routes>
        {!user ? (
          <Route path="/*" element={<AuthPage />} />
        ) : (
          <>
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/profiles" element={<PublicProfileFeed />} />
            <Route path="/profiles/:userId" element={<PublicProfile />} />
            {/* Redirect any unknown route to /inventory instead of /home */}
            <Route path="*" element={<Navigate to="/inventory" replace />} />
          </>
        )}
      </Routes>
    </>
  );
};

const App: React.FC = () => (
  <AuthProvider>
    <AppContent />
  </AuthProvider>
);

export default App;